/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_Note_Reads_AloudInputs */

const en_why_listening_compare_note_reads_aloud = /** @type {(inputs: Why_Listening_Compare_Note_Reads_AloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read aloud`)
};

const es_why_listening_compare_note_reads_aloud = /** @type {(inputs: Why_Listening_Compare_Note_Reads_AloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las lee en voz alta`)
};

/**
* | output |
* | --- |
* | "Read aloud" |
*
* @param {Why_Listening_Compare_Note_Reads_AloudInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_note_reads_aloud = /** @type {((inputs?: Why_Listening_Compare_Note_Reads_AloudInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_Note_Reads_AloudInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_note_reads_aloud(inputs)
	return en_why_listening_compare_note_reads_aloud(inputs)
});